/**
 * _sse.js — read a fetch() response as Server-Sent Events.
 *
 * The app's streaming endpoints (Chip AI chat, AI enhance, form fill) POST a
 * JSON body and answer with `text/event-stream`, which EventSource cannot do
 * (it is GET-only), so the stream is read off the fetch body by hand. Frames
 * are split on blank lines; each carries `event:` and one or more `data:`
 * lines holding JSON (application/api/_sse.py writes them). A frame with no
 * data, or data that is not JSON, is dropped.
 *
 * Imported by chip_fill_controller.js. ai_chat, public_chat, page_bar and
 * enhance_demo still carry their own copy of this loop.
 */

/**
 * Call `onEvent(event, data)` for every frame in `response`'s body, in order,
 * resolving when the stream ends. Rejects if the read fails or is aborted.
 */
export async function readSse(response, onEvent) {
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    for (;;) {
        const chunk = await reader.read();
        if (chunk.done) break;
        buffer += decoder.decode(chunk.value, { stream: true });
        let sep;
        while ((sep = buffer.indexOf("\n\n")) !== -1) {
            dispatchFrame(buffer.slice(0, sep), onEvent);
            buffer = buffer.slice(sep + 2);
        }
    }
}

function dispatchFrame(frame, onEvent) {
    let event = "message";
    const dataLines = [];
    frame.split("\n").forEach((line) => {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) dataLines.push(line.slice(5).trim());
    });
    if (!dataLines.length) return;
    let data;
    try { data = JSON.parse(dataLines.join("\n")); } catch (_e) { return; }
    onEvent(event, data);
}
